<div class="workspace bg-radial">
  <top-bar [titleTranslationCode]="'NAVIGATION.DASHBOARD'">
    <footer>
      <div class="row d-none d-md-flex">
        <div class="col-10">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item active" aria-current="page">
                  {{ "NAVIGATION.DASHBOARD" | translate }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </footer>
  </top-bar>
  <div class="container mt-md-3 mb-5">
    <div class="row position-relative pb-3">
      <spinner class="w-100 spinner"></spinner>
    </div>
    <section class="starter-offers mb-4">
      <ng-container *ngFor="let offer of starterOffers">
        <div *ngIf="isStarterAvailable(offer)" class="starter-offer" [ngClass]="offer.cssClass">
          <div class="course d-flex justify-content-between align-items-center">
            <div class="starter-offer__copy text-white">
              <h5 class="mb-1">{{ "DASHBOARD.STARTER.TITLE" | translate }}</h5>
              <div class="small">{{ "DASHBOARD.STARTER.SUBTITLE" | translate }}</div>
              <div class="small">{{ "DASHBOARD.STARTER.OFFER_VALID_FOR" | translate:{ time: offer.countdown } }}</div>
            </div>
            <a
              class="btn btn-primary rounded-pill"
              routerLink="/student/starter"
              [queryParams]="{ language: offer.lang }"
            >
              {{ "DASHBOARD.STARTER.BUTTON" | translate }}
            </a>
          </div>
        </div>
      </ng-container>
    </section>
    <div class="row row-cols-1 row-cols-xl-2 gy-5 mb-5">
      <!-- NEXT LESSON -->
      <div class="col">
        <div class="card h-100">
          <div class="card-header">
            <div class="row">
              <div class="col d-flex">
                <h4 class="my-auto">
                  {{ "DASHBOARD.NEXT_LESSON" | translate }}
                </h4>
              </div>
              <div class="col-auto d-flex align-items-center">
                <button
                  type="button"
                  class="btn btn-outline-secondary rounded-circle py-2"
                  aria-label="Next lesson help"
                  (click)="nextLessonHelpModal.show()"
                >
                  <app-icon name="question-mark" class="icon-gray"></app-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div *ngIf="lessons?.content.length > 0; else noResults" class="d-flex flex-column gap-3">
              <app-lesson-card *ngFor="let lesson of lessons?.content" [lesson]="lesson"
              [redirectPathPrefix]="'/student/col-lessons/school/' + schoolId + '/student/' + studentId + '/lesson'"></app-lesson-card>
            </div>
            <ng-template #noResults>
              <div class="row justify-content-center justify-content-sm-between gy-3">
                <div class="col-auto d-flex">
                  <p class="my-auto">
                    {{ "LESSONS.NO_FUTURE_LESSONS" | translate }}
                  </p>
                </div>
                <div class="col-auto">
                  <button routerLink="../reserve-lesson"
                          class="btn btn-primary rounded-pill">
                    {{ "BUTTON.BOOK_LESSON" | translate }}
                  </button>
                </div>
              </div>
            </ng-template>
          </div>
          <div class="card-footer border-0 text-end px-4 pb-3">
            <button routerLink="../col-lessons/school/{{schoolId}}/student/{{studentId}}"
                    class="btn btn-outline-primary rounded-pill me-2">
              {{ "DASHBOARD.ALL_LESSONS" | translate }}
            </button>
          </div>
        </div>
      </div>
      <!-- PROGRESS -->
      <div class="col">
        <div class="card h-100">
          <div class="card-header">
            <div class="row">
              <div class="col d-flex">
                <h4 class="my-auto">
                  {{ "NAVIGATION.PROGRESS" | translate }}
                </h4>
              </div>
              <div class="col-auto d-flex align-items-center">
                <button
                  type="button"
                  class="btn btn-outline-secondary rounded-circle py-2"
                  aria-label="Progress help"
                  (click)="progressHelpModal.show()"
                >
                  <app-icon name="question-mark" class="icon-gray"></app-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <app-progress-card-list></app-progress-card-list>
          </div>
        </div>
      </div>
      <!-- CREDITS -->
      <div class="col">
        <div class="card h-100">
          <div class="card-header">
            <div class="row">
              <div class="col d-flex">
                <h4 class="my-auto">
                  {{ "NAVIGATION.CREDITS" | translate }}
                </h4>
              </div>
              <div class="col-auto d-flex align-items-center">
                <button
                  type="button"
                  class="btn btn-outline-secondary rounded-circle py-2"
                  aria-label="Credits help"
                  (click)="creditsHelpModal.show()"
                >
                  <app-icon name="question-mark" class="icon-gray"></app-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <app-student-credits-short [studentId]="studentId"></app-student-credits-short>
          </div>
        </div>
      </div>
    </div>
    <!-- CALENDAR -->
    <div class="card h-100">
      <app-student-lessons-calendar
        [studentId]="studentId"
        (openHelpModal)="bookedLessonsHelpModal.show()"
      ></app-student-lessons-calendar>
    </div>
  </div>
</div>

<app-modal #bookedLessonsHelpModal>
  <div class="modal-content">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ "DASHBOARD.BOOKED_LESSONS_HELP.TITLE" | translate }}</h5>
      <button
        type="button"
        class="btn-close btn-close-white"
        aria-label="Close"
        (click)="bookedLessonsHelpModal.hide()"
      ></button>
    </div>
    <div class="modal-body p-4">
      <p class="mb-0">
        {{ "DASHBOARD.BOOKED_LESSONS_HELP.BODY_1" | translate }}
      </p>
      <p class="m-0">
        {{ "DASHBOARD.BOOKED_LESSONS_HELP.BODY_2" | translate }}
      </p>
    </div>
  </div>
</app-modal>

<app-modal #progressHelpModal>
  <div class="modal-content">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ "DASHBOARD.PROGRESS_HELP.TITLE" | translate }}</h5>
      <button
        type="button"
        class="btn-close btn-close-white"
        aria-label="Close"
        (click)="progressHelpModal.hide()"
      ></button>
    </div>
    <div class="modal-body p-4">
      <p class="mb-0">
        {{ "DASHBOARD.PROGRESS_HELP.BODY_1" | translate }}
      </p>
      <div class="d-flex my-3">
        <app-icon class="m-auto helper-icon" name="progress-icon"></app-icon>
      </div>
      <p class="m-0">
        {{ "DASHBOARD.PROGRESS_HELP.BODY_2" | translate }}
      </p>
    </div>
  </div>
</app-modal>

<app-modal #nextLessonHelpModal>
  <div class="modal-content">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ "DASHBOARD.NEXT_LESSON_HELP.TITLE" | translate }}</h5>
      <button
        type="button"
        class="btn-close btn-close-white"
        aria-label="Close"
        (click)="nextLessonHelpModal.hide()"
      ></button>
    </div>
    <div class="modal-body p-4">
      <p class="mb-0">
        {{ "DASHBOARD.NEXT_LESSON_HELP.BODY_1" | translate }}
      </p>
      <div class="d-flex my-3">
        <app-icon class="m-auto helper-icon" name="next-lesson-icon"></app-icon>
      </div>
      <p class="m-0">
        {{ "DASHBOARD.NEXT_LESSON_HELP.BODY_2" | translate }}
      </p>
    </div>
  </div>
</app-modal>

<app-modal #creditsHelpModal>
  <div class="modal-content">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ "COL.COURSES.CREDITS.HELP_MODAL.TITLE" | translate }}</h5>
      <button
        type="button"
        class="btn-close btn-close-white"
        aria-label="Close"
        (click)="creditsHelpModal.hide()"
      ></button>
    </div>
    <div class="modal-body p-4">
      <p class="mb-0">
        {{ "COL.COURSES.CREDITS.HELP_MODAL.BODY_1" | translate }}
      </p>
      <div class="d-flex my-3">
        <app-icon class="m-auto helper-icon" name="credits-icon"></app-icon>
      </div>
      <p class="m-0">
        {{ "COL.COURSES.CREDITS.HELP_MODAL.BODY_2" | translate }}
      </p>
      <p>
        {{ "COL.COURSES.CREDITS.HELP_MODAL.BODY_3" | translate }}
      </p>
    </div>
  </div>
</app-modal>

